import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import type { PairProcessorDeviceDto, PairProcessorDeviceResponseDto } from '@/types/dtos/processor/processor-pool.dto';
import { LIST_PROCESSOR_POOL_QUERY_KEY } from '@/state/queries/processor-admin/use-list-processor-pool';

export function usePairProcessorDeviceMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: PairProcessorDeviceDto) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/processor/pair-device`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body: params,
        token: token ?? '',
      }) as Promise<PairProcessorDeviceResponseDto>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_PROCESSOR_POOL_QUERY_KEY] });
    },
  });
}
